const timestamp = {
    get: times => {
        if (times) {
            let targetTime = new Date(times);
            let year = targetTime.getFullYear();
            let month = targetTime.getMonth() + 1;
            let day = targetTime.getDate();
            let hour = targetTime.getHours();
            let minute = targetTime.getMinutes();
    
            if(month >= 1 && month <= 9 )
                month = '0' + month
    
            if(day >= 0 && day <= 9)
                day = '0' + day
    
            if(hour >= 0 && hour <= 9)
                hour = '0' + hour
    
            if(minute >= 0 && minute <= 9)
                minute = '0' + minute
            
            return `${[year, month, day].join('-')} ${[hour, minute].join(':')}`;
        }

        return ''
    },
    getDates: times => {
        let targetTime = new Date(times);
        let year = targetTime.getFullYear();
        let month = targetTime.getMonth() + 1;
        let day = targetTime.getDate();

        if(month >= 1 && month <= 9 )
            month = '0' + month

        if(day >= 0 && day <= 9)
            day = '0' + day
        
        return `${[year, month, day].join('/')}`;
    },
    getTimes: times => {
        let targetTime = new Date(times);
        let hour = targetTime.getHours();
        let minute = targetTime.getMinutes();

        if(hour >= 0 && hour <= 9)
            hour = '0' + hour

        if(minute >= 0 && minute <= 9)
            minute = '0' + minute
        
        return `${[hour, minute].join(':')}`;
    },
    getHours: times => {
        let targetTime = new Date(times);
        let hour = targetTime.getHours();
        let minute = targetTime.getMinutes();

        if(hour >= 0 && hour <= 9)
            hour = '0' + hour

        minute =  Math.floor(10 / (60 / minute));
        
        return Number(`${[hour, minute].join('.')}`);
    },
    checkTime: (year, month, day) => {
        const checkTime = new Date(year, (month - 1), day).getDate() === day;
        
        if (!checkTime) return timestamp.checkTime(year, month, (day - 1));
        else return new Date([year, month, day].join('/'));
    },
    /**
     * 新增的函式：檢查給定的日期字串是否與當前日期屬於同一個月份 (同一年份且月份相同)
     * 依賴 timestamp.get 函式來獲取格式化後的 YYYY-MM
     * @param {string} dateString - 任何日期字串，格式如: '2025-09-28 20:54:52'
     * @returns {boolean} - 如果是當前月份，返回 true
     */
    isCurrentMonth: (dateString) => {
        if (!dateString) {
            return false;
        }

        // 由於 isCurrentMonth 依賴 timestamp.get 來確保日期格式一致，
        // 這裡需要確保傳入 new Date() 以獲取當前時間的格式化字串
        const currentFullDate = timestamp.get(new Date()); 
        // 擷取 YYYY-MM 部分
        const currentYearMonth = currentFullDate.substring(0, 7); 

        // 取得傳入日期的 YYYY-MM
        const invoiceFullDate = timestamp.get(dateString);
        const invoiceYearMonth = invoiceFullDate.substring(0, 7); 

        // 比較 YYYY-MM 是否相同
        return invoiceYearMonth === currentYearMonth;
    }
}

export default timestamp;